/* ============================================================
   MFF — Universal star fix
   File: assets/mff-stars-fix.js  (included from layout/theme.liquid)

   Problem: throughout the theme, star ratings are written with the
   ★ (U+2605) / ☆ (U+2606) text characters. No theme font contains
   those glyphs, so the browser draws them with a fallback font — which
   on some devices renders them as CJK glyphs (e.g. '复').

   Fix: replace every ★/☆ character anywhere on the page with an inline
   SVG star that uses fill:currentColor, so it matches the surrounding
   text colour and never depends on a font. Runs on load and watches for
   dynamically-added content.
   ============================================================ */
(function(){
  var FILL="<svg viewBox='0 0 24 24' aria-hidden='true' style='display:inline-block;width:1em;height:1em;vertical-align:-0.125em;fill:currentColor'><path d='M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'/></svg>";
  var EMPTY="<svg viewBox='0 0 24 24' aria-hidden='true' style='display:inline-block;width:1em;height:1em;vertical-align:-0.125em;fill:none;stroke:currentColor;stroke-width:1.6'><path d='M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'/></svg>";
  var SKIP={SCRIPT:1,STYLE:1,TEXTAREA:1,OPTION:1,NOSCRIPT:1};
  function process(root){
    if(!root) return;
    var walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,{acceptNode:function(n){
      var v=n.nodeValue;
      if(!v || (v.indexOf('★')<0 && v.indexOf('☆')<0)) return NodeFilter.FILTER_REJECT;
      var p=n.parentNode; if(!p||p.nodeType!==1) return NodeFilter.FILTER_REJECT;
      if(SKIP[p.nodeName]) return NodeFilter.FILTER_REJECT;
      if(p.isContentEditable) return NodeFilter.FILTER_REJECT;
      if(p.closest && p.closest('[data-mff-star]')) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    }});
    var nodes=[],n; while(n=walker.nextNode()) nodes.push(n);
    for(var i=0;i<nodes.length;i++){
      var node=nodes[i]; if(!node.parentNode) continue;
      var parts=node.nodeValue.split(/([★☆])/);
      if(parts.length<2) continue;
      var frag=document.createDocumentFragment();
      for(var j=0;j<parts.length;j++){
        var part=parts[j];
        if(part==='★'||part==='☆'){
          var s=document.createElement('span');
          s.setAttribute('data-mff-star','');
          s.style.display='inline-block';
          s.innerHTML=(part==='★')?FILL:EMPTY;
          frag.appendChild(s);
        } else if(part){ frag.appendChild(document.createTextNode(part)); }
      }
      node.parentNode.replaceChild(frag,node);
    }
  }
  var obs=null,t=null;
  function scan(){ if(obs)obs.disconnect(); process(document.body); if(obs)obs.observe(document.body,{subtree:true,childList:true,characterData:true}); }
  function start(){
    if(!document.body) return;
    process(document.body);
    if(!obs){ obs=new MutationObserver(function(){ clearTimeout(t); t=setTimeout(scan,60); }); }
    obs.observe(document.body,{subtree:true,childList:true,characterData:true});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start);} else {start();}
  window.addEventListener('load',function(){ if(!obs) start(); else scan(); });
})();
